import React, { useContext } from "react";
import { Trello } from "./trello";
import useIframe from "./_use-iframe";
import useRestApi from "./_use-rest-api";

interface ITrelloPowerUpContext {
  trelloIFrame: Trello.PowerUp.IFrame;
  restApi: ReturnType<typeof useRestApi>;
}

const TrelloPowerUpContext = React.createContext<
  ITrelloPowerUpContext | undefined
>(undefined);

export const TrelloPowerUpProvider = ({ children }) => {
  const restApi = useRestApi();
  const trelloIFrame = useIframe();

  const provider = {
    trelloIFrame,
    restApi,
  };

  return (
    <TrelloPowerUpContext.Provider value={provider}>
      {children}
    </TrelloPowerUpContext.Provider>
  );
};

export const useTrelloPowerUpContext = () => {
  const context = useContext<ITrelloPowerUpContext | undefined>(
    TrelloPowerUpContext
  );
  if (context === undefined) {
    throw new Error(
      "useTrelloPowerUpContext is undefined. Have you used it within a provider?"
    );
  }
  return context;
};
